'use client';

import { Field, Label, Radio } from '@headlessui/react';
import { Ref } from 'react';

import { styles } from './UiKitRadioTile.styles';

export interface UiKitRadioTileProps {
  label?: string;
  disabled?: boolean;
  value?: string;
  ref?: Ref<HTMLButtonElement>;
}

export function UiKitRadioTile({
  label,
  disabled,
  value,
  ref,
  ...props
}: UiKitRadioTileProps) {
  return (
    <Field
      className="relative"
      disabled={disabled}
    >
      <Radio
        ref={ref}
        value={value}
        {...props}
      >
        {({ checked }) => {
          const slots = styles({ checked, disabled });

          return (
            <div className={slots.radio()}>
              <div className={slots.radioInner()}>
                <span className={slots.dot()} />
              </div>
              {label && <Label className={slots.label()}>{label}</Label>}
            </div>
          );
        }}
      </Radio>
    </Field>
  );
}
